var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"color":"white"}},[_vm._v("la-chart-bar")])
}
var staticRenderFns = []

export { render, staticRenderFns }